import { InventoryType } from '@scaleaq/sitecontrol-lib';

import type { InventorySiteSectionSource } from './inventorySiteSections.types.ts';

/** Shared source for site-tabbed config that lists every accessible site (no inventory fetch). */
export const ACCESSIBLE_SITES_SOURCE = {
  kind: 'accessibleSites',
} as const satisfies InventorySiteSectionSource;

/** Pen picker site tabs scoped via cross-site type/query. */
export const PEN_TYPES_SOURCE = {
  kind: 'types',
  types: [InventoryType.Pen],
} as const satisfies InventorySiteSectionSource;

/** OrbitOne-backed widgets (biomass, lice count, sensor-by-provider) scoped via cross-site type/query. */
export const ORBIT_ONE_TYPES_SOURCE = {
  kind: 'types',
  types: [InventoryType.OrbitOne],
} as const satisfies InventorySiteSectionSource;

/** Feeding widget site tabs scoped to sites that have a feeding system. */
export const FEEDING_SYSTEM_TYPES_SOURCE = {
  kind: 'types',
  types: [InventoryType.FeedingSystem],
} as const satisfies InventorySiteSectionSource;

/** Site-tabbed config scoped to one or more inventory types (cross-site `type/query`). */
export const inventoryTypesSource = (
  types: readonly InventoryType[]
): InventorySiteSectionSource => ({
  kind: 'types',
  types: [...types],
});
